// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../../../types';

export default styled<any, Theme>('span')`
  background-color: ${props => props.theme.tileSelect.mostChosen.backgroundColor};
  border-radius: 0 ${props => props.theme.tileSelect.mostChosen.borderRadius};
  color: ${props => props.theme.tileSelect.mostChosen.color};
  font-size: .625rem;
  line-height: 1.5rem;
  padding: 0 .5rem;
  position: absolute;
  right: -3px;
  text-transform: uppercase;
  top: -3px;
`;
